import MinusIcon from '@/components/icons/MinusIcon';
import PlusIcon from '@/components/icons/PlusIcon';
import NextImage from '@/components/image';
import NextLink from '@/components/next-link';
import CurrencyIcon from '@/components/ui/icons/currency-icon';
import { handlePriceByComma } from '@/helpers/common';
import useHandleCart from '@/hooks/cart/useHandleCart';
import { setCookie } from 'cookies-next';

export default function CartItem({ item, t }) {
  const productName = Array.isArray(item?.name) ? item?.name?.[0] : item?.name;

  const { deleteItemFromCart, loading, handleUpdateCart } = useHandleCart();
  const loadingTypes = {
    deleting: 'deleting',
    adding: 'adding',
    subtracting: 'subtracting',
  };
  return (
    <div className='grid grid-cols-[72px_1fr_auto] items-center gap-3 rounded-2xl border border-[#e2e8f0] bg-[#f8fafc] p-2.5'>
      <div className='h-[72px] w-[72px] rounded-[10px] border-2 border-[#e2e8f0] bg-white p-1'>
        <NextImage
          className='h-full w-full object-contain'
          src={
            item?._media_?.image?.at(0)?.image ||
            (item?.extension_attributes?.product_image &&
              `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/catalog/product/${item?.extension_attributes?.product_image}`) ||
            item?.image_url ||
            `${process.env.NEXT_PUBLIC_IMG_BASEURL}/media/catalog/product/${item?.image}`
          }
          width={72}
          height={72}
          alt={productName}
        />
      </div>
      <div className='flex flex-1 flex-col'>
        <NextLink
          href={item?.extension_attributes?.innova_url || item?.innova_url}
          onClick={() => setCookie('product_view_type', 'cart-popup')}
          className='mt-0 mb-1.5 line-clamp-3 text-[14px] font-bold'
        >
          {productName}
        </NextLink>
        {/* <div className='text-[12px] text-[#64748b]'>{item.meta}</div> */}
        <div className='mt-2 flex items-center gap-2'>
          <div className='inline-flex items-center overflow-hidden rounded-xl border border-[#e2e8f0]'>
            <button
              className='cursor-pointer border-0 bg-white px-2.5 py-1.5 disabled:cursor-not-allowed disabled:opacity-50'
              aria-label={t('decrease')}
              onClick={() =>
                handleUpdateCart(true, item.item_id, item.qty, item)
              }
              disabled={item?.qty === 1 || loading}
            >
              {loading === loadingTypes.subtracting ? (
                <div className='size-4 animate-spin rounded-full border-t border-r border-[#aaa] py-1' />
              ) : (
                <MinusIcon className='size-3.5' />
              )}
            </button>
            <input
              type='text'
              inputMode='numeric'
              pattern='[0-9]*'
              value={item?.qty}
              readOnly
              className='w-9 border-0 bg-transparent py-1.5 text-center font-bold outline-none'
            />
            <button
              className='cursor-pointer border-0 bg-white px-2.5 py-1.5 disabled:cursor-not-allowed disabled:opacity-50'
              aria-label={t('increase')}
              disabled={loading}
              onClick={() =>
                handleUpdateCart(false, item.item_id, item.qty, item)
              }
            >
              {loading === loadingTypes.adding ? (
                <div className='size-4 animate-spin rounded-full border-t border-r border-[#aaa] py-1' />
              ) : (
                <PlusIcon className='size-3.5' />
              )}
            </button>
          </div>
          <button
            onClick={() => deleteItemFromCart(item, 'cart-popup')}
            className='cursor-pointer text-sm text-[#e53935] hover:underline disabled:cursor-not-allowed disabled:opacity-50'
            disabled={loading}
          >
            {loading === loadingTypes.deleting ? (
              <div className='size-4 animate-spin rounded-full border-t border-r border-red-500 py-1 md:border-red-500' />
            ) : (
              t('Delete')
            )}
          </button>
        </div>
      </div>
      <div className='price flex items-center gap-1 text-base font-semibold'>
        {handlePriceByComma(
          (item?.prices_with_tax?.price || item?.price_incl_tax) * item?.qty
        )}
        <CurrencyIcon className='size-3' />
      </div>
    </div>
  );
}
